exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width: 576px) {\n  .content {\n    margin: 0; }\n  .action-buttons-table, .table-head, .top-pagination {\n    display: none; }\n  .orders-page-buttons {\n    margin: 0 20px; }\n  .checkbox-status {\n    font-size: 12px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/assets/stylesheets/OrdersList.scss
// module id = 210
// module chunks = 0